export const DataList = [
    {id:1, name:"Сегодня"},
    {id:2, name:"Текущая неделя"},
    {id:3, name:"Текущий месяц"},
    {id:4, name:"Текущий год"},
    {id:5, name:"Вчера"},
    {id:5, name:"Прошлая неделя"},
    {id:6, name:"Прошлый месяц"},
    {id:7, name:"Прошлый год"},
    {id:8, name:"Все время"}
  ];
  

  export const TableHeader = [
    { key: "number", value: "Номер" },
    { key: "object", value: "Объект" },
    { key: "problemDescription", value: "Описание проблемы" },
    { key: "contractor", value: "Исполнитель" },
    { key: "repairPrice", value: "Бюджет ремонта" },
    { key: "status", value: "Статус заявки" },
];
